import { sendAIFCExperienceTrackingToParent } from './index';

const REMIX_REGENERATE_EXPERIENCE = 'aiMateRemixRegenerate';

type RemixRegenerateExperienceMetadata = {
	instrumentationId?: string;
	remixType?: string;
	remixSubtype?: string;
	isSafetyViolation?: boolean;
};

type RemixRegenerateFailureMetadata = RemixRegenerateExperienceMetadata & {
	error: string;
	failureReason?:
		| 'backend_action_error'
		| 'stream_interrupted_after_prepare'
		| 'upload_and_insert_failed';
	failureStage?: 'backend_action' | 'frontend_apply' | 'stream_lifecycle';
	streamAbortReason?: 'aborted' | 'user_abort';
	traceId?: string;
};

type RemixRegenerateAbortMetadata = RemixRegenerateExperienceMetadata & {
	reason: string;
	streamAbortReason?: 'user_abort';
	traceId?: string;
};

export const remixRegenerateExperience: {
	start: () => void;
	success: (args?: RemixRegenerateExperienceMetadata) => void;
	fail: (args: RemixRegenerateFailureMetadata) => void;
	abort: (args: RemixRegenerateAbortMetadata) => void;
} = {
	start: () =>
		sendAIFCExperienceTrackingToParent({
			status: 'start',
			experienceName: REMIX_REGENERATE_EXPERIENCE,
		}),
	success: (args) =>
		sendAIFCExperienceTrackingToParent({
			status: 'success',
			...(args?.instrumentationId && { attributes: { instrumentationId: args.instrumentationId } }),
			experienceName: REMIX_REGENERATE_EXPERIENCE,
			...(args?.remixType && { remixType: args.remixType }),
			...(args?.remixSubtype && { remixSubtype: args.remixSubtype }),
			...(args?.isSafetyViolation && { isSafetyViolation: args.isSafetyViolation }),
		}),
	fail: ({
		error,
		failureReason,
		failureStage,
		remixType,
		remixSubtype,
		streamAbortReason,
		traceId,
		instrumentationId,
	}) =>
		sendAIFCExperienceTrackingToParent({
			status: 'fail',
			experienceName: REMIX_REGENERATE_EXPERIENCE,
			error,
			...(remixType && { remixType }),
			...(remixSubtype && { remixSubtype }),
			...((failureReason || failureStage || streamAbortReason || traceId || instrumentationId) && {
				attributes: {
					...(instrumentationId && { instrumentationId }),
					...(failureReason && { failureReason }),
					...(failureStage && { failureStage }),
					...(streamAbortReason && { streamAbortReason }),
					...(traceId && { traceId }),
				},
			}),
		}),
	abort: ({ reason, instrumentationId, remixType, remixSubtype, streamAbortReason, traceId }) =>
		sendAIFCExperienceTrackingToParent({
			status: 'abort',
			experienceName: REMIX_REGENERATE_EXPERIENCE,
			reason,
			...(remixType && { remixType }),
			...(remixSubtype && { remixSubtype }),
			...((instrumentationId || streamAbortReason || traceId) && {
				attributes: {
					...(instrumentationId && { instrumentationId }),
					...(streamAbortReason && { streamAbortReason }),
					...(traceId && { traceId }),
				},
			}),
		}),
};
